import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  FormOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const AvaliacoesCadGrupos = () => {
  const { id_formulario } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // PRODUTO
  const [formulario, setFormulario] = useState(null);

  useEffect(() => {
    if (id_formulario) {
      carregarFormulario(id_formulario);
      listarGrupos(id_formulario);
    }
  }, [id_formulario]);

  // CARREGAR FORMULÁRIO
  const carregarFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setFormulario(api?.response?.data);
    } else {
      navigate("/avaliacoes/formularios");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarGrupos = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_grupos/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarGrupo = async (formulario) => {
    if (!formulario?.id_avaliacoes_cad_formularios) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_grupos/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarGrupos(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarGrupo = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_grupos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarGrupos(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarGrupo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_grupos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        ordem: api.response.data.ordem,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarGrupo = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_grupos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarGrupos(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Descrição",
    },
    {
      dataIndex: "ordem",
      title: "Ordem",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Questões">
            <Button
              loading={loading}
              onClick={() => navigate(`/avaliacoes/formularios/grupos/${id_formulario}/questoes/${e.id}`)}
              icon={<OrderedListOutlined />}
            />
          </Tooltip>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarGrupo(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              danger
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarGrupo(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_avaliacoes_cad_formularios = id_formulario && id_formulario;
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarGrupo(formulario);
    } else {
      cadastrarGrupo(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Grupo
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="ordem" label="Ordem" rules={[{ required: true, message: "Digite a ordem!" }]}>
                <InputNumber
                  className="input-number"
                  precision={0}
                  size="large"
                  min={1}
                  max={1000}
                  disabled={loading}
                  placeholder="Informe a ordem"
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes/formularios")} />
            <HeaderTitle
              title="Avaliações Gestão Grupos"
              subtitle={
                <Text italic>
                  <FormOutlined /> {formulario?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
